import { render, staticRenderFns } from "./GetOrganization.vue?vue&type=template&id=44bb2618&scoped=true&"
import script from "./GetOrganization.vue?vue&type=script&lang=js&"
export * from "./GetOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb2618",
  null
  
)

export default component.exports